module.exports = {
  convert: require('./phpPecl').convert,
  getOptions: require('./phpPecl').getOptions
};
